// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1F7gD","input":"Form_input__1jqBF","result":"Form_result__15EKn","flexbox":"Form_flexbox__3Vydl","clear":"Form_clear__Ps_Ws"};